var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.996,
    height: 28.996,
    viewBox: "0 0 28.996 28.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-svgrepo-com",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M11.573,8.826a1.911,1.911,0,0,0-.642.751.988.988,0,0,1-1.767-.883,3.858,3.858,0,0,1,1.314-1.513A4.315,4.315,0,0,1,12.93,6.5a4.3,4.3,0,0,1,2.549.816A3.229,3.229,0,0,1,16.8,9.96a3.928,3.928,0,0,1-1.354,2.919c-.25.241-.526.472-.763.67l-.194.162a5.706,5.706,0,0,0-.573.539v1.806a.988.988,0,1,1-1.977,0V14.114a1.576,1.576,0,0,1,.326-.97,6.7,6.7,0,0,1,.946-.941l.241-.2h0c.227-.188.427-.356.619-.543a1.976,1.976,0,0,0,.75-1.5A1.256,1.256,0,0,0,14.293,8.9a2.327,2.327,0,0,0-1.363-.42A2.371,2.371,0,0,0,11.573,8.826Zm2.676,11.513a1.318,1.318,0,1,1-1.318-1.318A1.318,1.318,0,0,1,14.248,20.339Z",
    transform: "translate(2.567 1.749)",
    fill: "#0B8275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M15.5,1A14.5,14.5,0,1,0,30,15.5,14.5,14.5,0,0,0,15.5,1ZM2.977,15.5A12.521,12.521,0,1,1,15.5,28.019,12.521,12.521,0,0,1,2.977,15.5Z",
    fill: "#0B8275",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogo2);
export default __webpack_public_path__ + "static/media/navbar-logo-2.0aef23fcfa40adae88443db1bef9eb0c.svg";
export { ForwardRef as ReactComponent };